export enum Field {
  CountryId = 'countryId',
  Name = 'name',
  Line1 = 'line1',
  Line2 = 'line2',
  PostalCode = 'postalCode',
  City = 'city',
}

export type FormModel = {
  [Field.CountryId]: number
  [Field.Name]: string
  [Field.Line1]: string
  [Field.Line2]?: string
  [Field.PostalCode]: number | null
  [Field.City]: string | null
}

export type CityOption = {
  value: string
  label: string
}

export type PostalCodeConstraint = {
  format: string
  minLength: number
  maxLength: number
}
